export default "__VITE_ASSET__7838bffe__"